export default "__VITE_ASSET__BG8lGE5h__"